var render = function (_h,_vm) {var _c=_vm._c;return _c('iframe',{attrs:{"src":_vm.props.attributes.value,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }